module.exports = __webpack_public_path__ + "static/img/xzicon03.png";